import { Component, EventEmitter, Input, Output } from '@angular/core';

export type NationalIdChoice = 'existing' | 'new';

export interface NationalIdChoiceDialogData {
  // last 4 digits of the saved National ID, as returned by the server (409 NATIONAL_ID_CHOICE_REQUIRED)
  existingLast4: string;
  // the National ID the admin typed — shown as is (the admin entered it)
  newNationalId: string;
  phone: string;
  dir: 'ltr' | 'rtl';
}

// B1 (BLU-47): the phone matches an account with no staff role and another National ID.
// Rendered inside #addStaffModal (not a MatDialog), so it always sits on top of the Add staff modal
// and Bootstrap's modal focus trap does not fight it.
// Emits the picked choice, or null on Back / ×.
@Component({
  selector: 'app-national-id-choice-dialog',
  templateUrl: './national-id-choice-dialog.component.html',
  styleUrls: ['./national-id-choice-dialog.component.scss']
})
export class NationalIdChoiceDialogComponent {
  @Input() data: NationalIdChoiceDialogData;
  @Output() closed = new EventEmitter<NationalIdChoice | null>();
  choice: NationalIdChoice = null;

  back(): void {
    this.closed.emit(null);
  }

  useThis(): void {
    if (this.choice) {
      this.closed.emit(this.choice);
    }
  }
}
